module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-310x310-8d9e0642eb7b853708fb380a7c63926c.png";